/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Navigate,
  useRouteError
} from 'react-router';
import { BaseLayout } from '@/layouts';
import PrivateRoute from './PrivateRoute';

const Dashboard = lazy(() => import('@/views/Dashboard'));
const SeatMap = lazy(() => import('@/views/SeatMap'));
const NotFound = lazy(() => import('@/views/NotFound'));
const Login = lazy(() => import('@/views/Login'));
const Redeem = lazy(() => import('@/views/Redeem'));

function RootErrorBoundary() {
  const error = useRouteError() as Error;
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<BaseLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={lazyView(<Dashboard />)} />
          <Route path="seat-map/:area" element={lazyView(<SeatMap />)} />
          <Route path="redeem" element={lazyView(<Redeem />)} />
        </Route>
      </Route>
      <Route path="/login" element={lazyView(<Login />)} />
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
